<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-form size="small">
          <el-row :gutter="15">
            <el-col :span="12">
              <DateForm ref="dateForm" />
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item
                label="Customer"
              >
                <AccountAutoComplete
                  ref="accountAutoComplete"
                  v-model="account"
                  @loadCarrier="loadCarrier"
                />
                <el-checkbox
                  v-model="form.showChildrenAccts"
                  label="Include Child Accounts"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Carrier (for Customer)">
                <CarrierAutoCompleteByAccountID
                  ref="carrierList"
                  v-model="form.carrierId"
                  :disabled="(form.accountId == null)"
                  :carrier-settings="carrierSettings"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                class="float-right"
                @click.native="downloadCSV()"
              >
                Generate Report
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Billing Report"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import CarrierAutoCompleteByAccountID from '@/components/Application/Reports/CarrierAutoCompleteByAccountID'
import AccountAutoComplete from '@/components/Application/Reports/AccountAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    DateForm,
    AccountAutoComplete,
    CarrierAutoCompleteByAccountID,
    Preview
  },
  data () {
    return {
      pageTitle: 'Billing Report',
      breadcrumb: {
        name: 'Billing Report',
        route: { name: 'reports-freight-billing' }
      },
      account: {},
      carrierSettings: [],
      form: {
        dateFrom: null,
        dateTo: null,
        accountId: null,
        showChildrenAccts: false,
        carrierId: ''
      },
      isShowPreview: false,
      configuration: null
    }
  },
  watch: {
    account (newValue) {
      if (newValue.carrier_settings) {
        this.carrierSettings = newValue.carrier_settings
      }
      if (newValue.id) {
        this.form.accountId = newValue.id
      } else {
        this.form.accountId = null
        this.carrierId = null
        this.carrierSettings = []
        this.$refs.carrierList.input = ''
      }
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    loadCarrier () {
      this.form.accountId = this.$refs.accountAutoComplete.getAccountIds()
      this.carrierSettings = this.$refs.accountAutoComplete.getCarriers()
    },
    downloadCSV () {
      this.$refs.dateForm.$refs.form
        .validate(async (valid) => {
          if (valid) {
            this.setDate(this.$refs.dateForm.form.value)
            this.form.carrierId = this.$refs.carrierList.getCarrierId()
            this.configuration = {
              report: 'Billing',
              params: this.form
            }
            this.isShowPreview = true
          }
        })
    }
  }
}
</script>
